export default __webpack_public_path__ + "static/avatar-kayi-special-1-9ebeb420f442956d2162ef53c5e263ff.png";